import React, { useEffect, useState } from 'react'

function AdminDashboard({ adminKey }) {
    const [ voters, setVoters ] = useState()
    const [ activePoll, setActivePoll ] = useState()
    const [ pollStatus, setPollStatus ] = useState()

    // input fields
    const [ nameInput, setNameInput ] = useState("")
    const [ emailInput, setEmailInput ] = useState("")

    const [ questionInput, setQuestionInput ] = useState("")
    const [ choiceInput, setChoiceInput ] = useState("")
    const [ choices, setChoices ] = useState([])

    useEffect(() => {
        fetch("/api/admin/voter", {
            headers: {
                "x-admin-key": adminKey
            }
        })
            .then(r => {
                if (r.ok)
                    return r.json()
            })
            .then(r => {
                setVoters(r.response)
            })

        fetch("/api/admin/poll", {
            headers:{
                "x-admin-key": adminKey
            }
        })
            .then(r => {
                if (r.ok)
                    return r.json()
            })
            .then(r => {
                setActivePoll(r.response)
            })

        const f = () => {
            fetch("/api/admin/vote-status", {
                headers: {
                    "x-admin-key": adminKey
                }
            })
                .then(r => r.json())
                .then(r => setPollStatus(r.response))
        }
        f()
        setInterval(() => {
            f()
        }, 5000)
    }, [])

    const handleDelete = (toDelete) => {
        fetch("/api/admin/voter", {
            method: "DELETE",
            headers: {
                "x-admin-key": adminKey
            },
            body: JSON.stringify({
                "email": toDelete
            })
        })
            .then(r => {
                if (r.ok)
                    return r
            })
            .then(() => {
                let locVoters = { ...voters }
                delete locVoters[toDelete]
                setVoters(locVoters) 
            })
    }

    const handleAddVoter = event => {
        event.preventDefault()
        fetch("/api/admin/voter", {
            method: "POST",
            headers: {
                "x-admin-key": adminKey
            },
            body: JSON.stringify({
                "email": emailInput,
                "name": nameInput
            })
        })
            .then(r => {
                if (r.ok)
                    return r
            })
            .then(() => {
                let locVoters = { ...voters }
                locVoters[emailInput] = nameInput
                setVoters(locVoters)

                setNameInput("")
                setEmailInput("")
            })
    }

    const handleStopPoll = event => {
        event.preventDefault()
        fetch("/api/admin/poll", {
            method: "DELETE",
            headers: {
                "x-admin-key": adminKey
            }
        })
            .then(r => r.json())
            .then(r => {
                let downloadElem = document.createElement("a")
                let blob = new Blob([JSON.stringify(r.response, null, 4)], { type: "application/json" })
                let url = URL.createObjectURL(blob)
                downloadElem.href = url
                downloadElem.download = `export_${new Date().toISOString()}.json`
                
                document.body.appendChild(downloadElem)
                downloadElem.click()
                document.body.removeChild(downloadElem)

                setActivePoll(null)
                setQuestionInput("")
                setChoiceInput("")
                setChoices([])
            })
    }
    
    const handleCreatePoll = event => {
        event.preventDefault()

        fetch("/api/admin/poll", {
            method: "POST",
            headers: {
                "x-admin-key": adminKey
            },
            body: JSON.stringify({
                "question": questionInput,
                "choices": choices
            })
        })
            .then(r => r.json())
            .then(r => {
                setActivePoll({
                    "question": questionInput,
                    "choices": choices
                })
            })
    }

    return (
        <div>
            <h1>Admin Dashboard</h1>
            {/* List of Voters */}
            <article>
                <header>
                    Aktuell zugelassene Voter
                </header>
                <ul>
                    { voters && Object.keys(voters).map((obj, i) => (
                        <li key={i}>
                            <span>{voters[obj]}</span> (<span>{obj}</span>) <a href="#" onClick={() => handleDelete(obj)}>Löschen</a>
                        </li>
                    ))}
                </ul>
                <footer>
                    <form className="grid" onSubmit={handleAddVoter}>
                        <div>
                            <input 
                                type="name" 
                                placeholder="Name"
                                value={nameInput}
                                onChange={e => setNameInput(e.target.value)}
                            />
                        </div>
                        <div>
                            <input 
                                type="email" 
                                placeholder="Email"
                                value={emailInput}
                                onChange={e => setEmailInput(e.target.value)}
                            />
                        </div>
                        <div>
                            <button 
                                type="submit"
                            >Anlegen</button>
                        </div>
                    </form>
                </footer>
            </article>

            {/* Active poll card */}
            { activePoll
                ? (
                    <>
                        <article>
                            <header>
                                Aktive Poll
                            </header>
                            <div>
                                { activePoll && (
                                    <>
                                        <h5>{ activePoll.question }</h5>
                                        <ul>
                                            { activePoll.choices && activePoll.choices.map(c => (
                                                <li>{c}</li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                            <footer>
                                <button onClick={handleStopPoll}>
                                    Poll stoppen und exportieren
                                </button>
                            </footer>
                        </article>

                        {/* active status */}
                        <article>
                            <header>
                                Voter, die für diese Poll bereits abgestimmt haben
                            </header>
                            <ul>
                                { pollStatus && Object.keys(pollStatus).map((obj, i) => (
                                    <li key={i}>
                                        <span>{obj}</span>
                                    </li>
                                ))}
                            </ul>
                        </article>
                    </>
                )
                : (
                    <article>
                        <header>
                            Neue Poll erstellen (aktuell läuft keine Poll)
                        </header>
                        <form>
                            <input 
                                type="text" 
                                placeholder="Frage"
                                value={questionInput}
                                onChange={e => setQuestionInput(e.target.value)}
                            />
                            <div className="grid">    
                                <input 
                                    type="text" 
                                    placeholder="Auswahl hinzufügen"
                                    value={choiceInput}
                                    onChange={e => setChoiceInput(e.target.value)}
                                />
                                <button 
                                    className="secondary"
                                    onClick={e => {
                                        e.preventDefault()
                                        let newChoices = [...choices]
                                        newChoices.push(choiceInput)
                                        setChoices(newChoices)
                                    }}
                                >Hinzufügen</button>
                            </div>
                            <ul>
                                { choices && choices.map(c => 
                                    <li>{c}</li>   
                                )}
                            </ul>
                        </form>
                        <footer>
                            <button
                                onClick={handleCreatePoll}
                            >Poll anlegen und freischalten</button>
                        </footer>
                    </article>
                )}
        </div>
    )
}

export default AdminDashboard;